// src/core/services/userpoint.service.js
import axios from "../utils/axios.wrapper";

// GET api/v1/UserPoints
export const getUserPoints = async () => {
  const { data } = await axios.get("/userpoints/active");
  return data.items || data;
};

// GET api/v1/UserPoints/employee/{employeeId}
export const getUserPointsByEmployee = async (employeeId) => {
  const { data } = await axios.get(`/userpoints/employee/${employeeId}`);
  return data.items || data;
};

// GET api/v1/UserPoints/{id}
export const getUserPointById = async (id) => {
  const { data } = await axios.get(`/userpoints/${id}`);
  return data;
};

// POST api/v1/UserPoints/create
export const createUserPoint = async (userPoint) => {
  const { data } = await axios.post("/userpoints/create", userPoint);
  return data;
};

// POST api/v1/UserPoints/create
export const createBulkUserPoint = async (userPoint) => {
    console.log("Payload", userPoint);
  const { data } = await axios.post("/userpoints/bulk-create", userPoint);
  return data;
};

// PUT api/v1/UserPoints/{id}
export const updateUserPoint = async (id, userPoint) => {
  const { data } = await axios.put(`/userpoints/${id}`, userPoint);
  return data;
};

// DELETE soft api/v1/UserPoints/{id}
export const softDeleteUserPoint = async (id) => {
  const { data } = await axios.delete(`/userpoints/${id}`);
  return data;
};

// DELETE hard api/v1/UserPoints/hard/{id}
export const hardDeleteUserPoint = async (id) => {
  const { data } = await axios.delete(`/userpoints/hard/${id}`);
  return data;
};

export const userPointService = {
  getUserPoints,
  getUserPointsByEmployee,
  getUserPointById,
  createUserPoint,
  updateUserPoint,
  softDeleteUserPoint,
  hardDeleteUserPoint,
  createBulkUserPoint,
};
